<template>
  <div v-if='isTranslation' class="severity" :class="severityClass">
    {{ $t(issue.severity) }}
  </div>
  <div v-else class="severity" :class="severityClass">
    {{ issue.severity }}
  </div>
</template>

<script>
export default {
  name: 'IssueSeverity',
  props: {
    issue: {
      type: Object,
      required: true,
    },
    isTranslation: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    severityClass() {
      return !this.issue.severity || this.issue.severity === 'N/A' || this.issue.severity === 'info' ? 'informative' : this.issue.severity.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.severity {
  text-transform: capitalize;
  font-family: $font-family-medium;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: rem(25);
  &.informative {
    color: $severity-trivial;
  }
  &.trivial {
    color: $severity-trivial;
  }
  &.low {
    color: $severity-low;
  }
  &.medium {
    color: $severity-medium;
  }
  &.high {
    color: $severity-high;
  }
  &.critical {
    color: $severity-critical;
  }
  &.blocker {
    color: $severity-critical;
    font-weight: bold;
  }
}
</style>
